import { shallowEqual } from '@shared/util/array';
import { DependencyList, useEffect, useRef } from 'react';
import usePrevious from './usePrevious';

/**
 * Similar to the standard useEffect, but doesn't run on mount.
 * @see useEffect
 */
const useUpdateEffect = (callback: () => void, deps: DependencyList) => {
  const firstRef = useRef(true);
  const previousDeps = usePrevious(deps);
  useEffect(() => {
    if (firstRef.current) {
      firstRef.current = false;
      return;
    }
    // this may not be necessary, but this hook gets called on hot reload in dev mode otherwise 😮‍💨
    if (shallowEqual(deps, previousDeps)) {
      return;
    }
    callback();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
};

export default useUpdateEffect;
